// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module__container___2JU9I","dashedBorderVertical":"style-module__dashedBorderVertical___NPxGz"};